export class ChartContainer {
    guid: string;
    name: string;
    description: string;
    createdDate: Date;
    createdBy: string;
}